/**
 * §4.4 / §UC-26: コア機能の機能検出。
 *
 * 起動時に以下を確認し、 利用不可なら非対応案内画面を表示してコア機能をブロックする:
 *   - Document Picture-in-Picture API (`window.documentPictureInPicture`)
 *   - getUserMedia({ video: true })
 *   - WebGL2 (MediaPipe Tasks Vision の WebGL バックエンド前提)
 *
 * IndexedDB は不在/失敗でも degrade で継続するためここでは判定しない (§3.12)。
 * issue #130 で audio VAD 撤去後は mic permission を要求しないため `audio` constraint も検出しない。
 */

type FeatureSupport = {
  ok: boolean;
  missing: string[];
};

export function detectCoreFeatures(): FeatureSupport {
  const missing: string[] = [];

  if (typeof window === "undefined" || !("documentPictureInPicture" in window)) {
    missing.push("Document Picture-in-Picture API");
  }

  if (
    typeof navigator === "undefined" ||
    !navigator.mediaDevices ||
    typeof navigator.mediaDevices.getUserMedia !== "function"
  ) {
    missing.push("カメラ (getUserMedia)");
  }

  if (typeof document !== "undefined") {
    try {
      const canvas = document.createElement("canvas");
      const gl = canvas.getContext("webgl2");
      if (!gl) missing.push("WebGL2");
    } catch {
      missing.push("WebGL2");
    }
  }

  return { ok: missing.length === 0, missing };
}
